export enum HomePageButtonStyle {
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}

export type HomePageLanguageCode = 'en' | 'nl' | 'de' | 'fr'

export type HomePageLocalizedValue = Partial<
  Record<HomePageLanguageCode, string>
>

export interface HomePageButton {
  title: HomePageLocalizedValue
  url: string
  icon: string
  style: HomePageButtonStyle
  order: number
}

export interface HomePageSlide {
  imageUrl: HomePageLocalizedValue
  altText?: HomePageLocalizedValue
  url?: string
  order: number
}

export interface HomePageConfigWebOption {
  title: HomePageLocalizedValue
  slides: HomePageSlide[]
  buttons: HomePageButton[]
}
